export interface ChangelogChange {
  type: 'feature' | 'fix' | 'improvement' | 'breaking';
  category: string;
  titleEn: string;
  titleHu: string;
  titleDe?: string;
  titleUk?: string;
  descriptionEn?: string;
  descriptionHu?: string;
  descriptionDe?: string;
  descriptionUk?: string;
}

export interface ChangelogEntry {
  version: string;
  date: string;
  changes: ChangelogChange[];
}

/**
 * Changelog data — Insert new versions at the TOP of this array.
 * Target for bmad-release-update skill.
 */
export const changelogData: ChangelogEntry[] = [
  {
    version: '4.2.0',
    date: '2026-04-03',
    changes: [
      // ─── Csomag rendszer (Package System) ───
      {
        type: 'feature',
        category: 'packages',
        titleHu:
          'Csomag kezel\u0151 rendszer \u2014 g\u00e9p + fogyoeszk\u00f6z + tartoz\u00e9k egy csomagban',
        titleEn:
          'Package Management System \u2014 equipment + consumables + accessories in one bundle',
        titleDe:
          'Paketverwaltungssystem \u2014 Ger\u00e4te + Verbrauchsmaterial + Zubeh\u00f6r in einem Paket',
        titleUk:
          '\u0421\u0438\u0441\u0442\u0435\u043c\u0430 \u0443\u043f\u0440\u0430\u0432\u043b\u0456\u043d\u043d\u044f \u043f\u0430\u043a\u0435\u0442\u0430\u043c\u0438 \u2014 \u043e\u0431\u043b\u0430\u0434\u043d\u0430\u043d\u043d\u044f + \u0432\u0438\u0442\u0440\u0430\u0442\u043d\u0456 \u043c\u0430\u0442\u0435\u0440\u0456\u0430\u043b\u0438 + \u0430\u043a\u0441\u0435\u0441\u0443\u0430\u0440\u0438 \u0432 \u043e\u0434\u043d\u043e\u043c\u0443 \u043f\u0430\u043a\u0435\u0442\u0456',
        descriptionHu:
          'Mostant\u00f3l a b\u00e9rl\u00e9shez \u00f6ssze\u00e1ll\u00edthat\u00f3 csomagok k\u00e9sz\u00edthet\u0151k, amelyek h\u00e1rom f\u00e9le t\u00e9telt tartalmazhatnak: b\u00e9rg\u00e9p (napi d\u00edjjal), bizom\u00e1nyos fogyoeszk\u00f6z (pl. v\u00e1g\u00f3korong, f\u00far\u00f3sz\u00e1r \u2014 amit a v\u00e1s\u00e1rl\u00f3 elvisz \u00e9s visszahoz\u00e1skor sz\u00e1mol el), \u00e9s ingyenes tartoz\u00e9k (pl. sz\u00e9nkefe). A csomagok az Admin Center / Csomagok oldalon kezelhet\u0151k: n\u00e9v, \u00e1raz\u00e1s, t\u00e9telek \u00f6ssze\u00e1ll\u00edt\u00e1sa.',
        descriptionEn:
          'You can now create rental bundles (packages) with three item types: rental equipment (daily rate), consignment consumables (e.g. cutting discs, drill bits \u2014 customer takes them and pays only for what they use upon return), and free accessories (e.g. carbon brushes). Packages are managed in Admin Center / Packages: name, pricing, item composition.',
        descriptionDe:
          'Jetzt k\u00f6nnen Mietpakete mit drei Artikeltypen erstellt werden: Mietger\u00e4te (Tagessatz), Konsignationsverbrauchsmaterial (z.B. Trennscheiben \u2014 Kunde nimmt mit und zahlt nur f\u00fcr Verbrauchtes bei R\u00fcckgabe) und kostenloses Zubeh\u00f6r (z.B. Kohlenb\u00fcrsten). Verwaltung unter Admin Center / Pakete.',
        descriptionUk:
          '\u0422\u0435\u043f\u0435\u0440 \u043c\u043e\u0436\u043d\u0430 \u0441\u0442\u0432\u043e\u0440\u044e\u0432\u0430\u0442\u0438 \u043e\u0440\u0435\u043d\u0434\u043d\u0456 \u043f\u0430\u043a\u0435\u0442\u0438 \u0437 \u0442\u0440\u044c\u043e\u043c\u0430 \u0442\u0438\u043f\u0430\u043c\u0438 \u0442\u043e\u0432\u0430\u0440\u0456\u0432: \u043e\u0440\u0435\u043d\u0434\u043d\u0435 \u043e\u0431\u043b\u0430\u0434\u043d\u0430\u043d\u043d\u044f, \u043a\u043e\u043d\u0441\u0438\u0433\u043d\u0430\u0446\u0456\u0439\u043d\u0456 \u0432\u0438\u0442\u0440\u0430\u0442\u043d\u0456 \u043c\u0430\u0442\u0435\u0440\u0456\u0430\u043b\u0438 (\u043a\u043b\u0456\u0454\u043d\u0442 \u0437\u0430\u0431\u0438\u0440\u0430\u0454 \u0456 \u043f\u043b\u0430\u0442\u0438\u0442\u044c \u043b\u0438\u0448\u0435 \u0437\u0430 \u0432\u0438\u043a\u043e\u0440\u0438\u0441\u0442\u0430\u043d\u0435 \u043f\u0440\u0438 \u043f\u043e\u0432\u0435\u0440\u043d\u0435\u043d\u043d\u0456) \u0442\u0430 \u0431\u0435\u0437\u043a\u043e\u0448\u0442\u043e\u0432\u043d\u0456 \u0430\u043a\u0441\u0435\u0441\u0443\u0430\u0440\u0438. \u041a\u0435\u0440\u0443\u0432\u0430\u043d\u043d\u044f \u0432 \u0410\u0434\u043c\u0456\u043d-\u0446\u0435\u043d\u0442\u0440\u0456 / \u041f\u0430\u043a\u0435\u0442\u0438.',
      },
      // ─── B\u00e9rl\u00e9s + csomag ───
      {
        type: 'feature',
        category: 'rental',
        titleHu: 'Csomag kiv\u00e1laszt\u00e1s a b\u00e9rl\u00e9si var\u00e1zsl\u00f3ban',
        titleEn: 'Package selection in the rental wizard',
        titleDe: 'Paketauswahl im Miet-Assistenten',
        titleUk:
          '\u0412\u0438\u0431\u0456\u0440 \u043f\u0430\u043a\u0435\u0442\u0443 \u0432 \u043c\u0430\u0439\u0441\u0442\u0440\u0456 \u043e\u0440\u0435\u043d\u0434\u0438',
        descriptionHu:
          'A b\u00e9rl\u00e9s ind\u00edt\u00e1sakor v\u00e1laszthat egyedi g\u00e9pet VAGY el\u0151re \u00f6ssze\u00e1ll\u00edtott csomagot. A csomag eset\u00e9n a rendszer automatikusan hozz\u00e1adja a g\u00e9pet, a fogyoeszk\u00f6z\u00f6ket \u00e9s a tartoz\u00e9kokat. A Részletek l\u00e9p\u00e9sn\u00e9l l\u00e1that\u00f3 a bizom\u00e1ny \u00e9rt\u00e9ke, az \u00d6sszegz\u00e9sben pedig minden t\u00e9tel felsorolva.',
        descriptionEn:
          'When starting a rental, you can choose individual equipment OR a pre-configured package. With a package, the system automatically adds the equipment, consumables, and accessories. The Details step shows the consignment value, and the Summary lists all items.',
        descriptionDe:
          'Beim Start einer Vermietung kann Einzelger\u00e4t ODER ein vorkonfiguriertes Paket gew\u00e4hlt werden. Bei einem Paket werden Ger\u00e4t, Verbrauchsmaterial und Zubeh\u00f6r automatisch hinzugef\u00fcgt. Die Details zeigen den Konsignationswert, die Zusammenfassung listet alle Artikel auf.',
        descriptionUk:
          '\u041f\u0440\u0438 \u0441\u0442\u0430\u0440\u0442\u0456 \u043e\u0440\u0435\u043d\u0434\u0438 \u043c\u043e\u0436\u043d\u0430 \u043e\u0431\u0440\u0430\u0442\u0438 \u043e\u043a\u0440\u0435\u043c\u0435 \u043e\u0431\u043b\u0430\u0434\u043d\u0430\u043d\u043d\u044f \u0410\u0411\u041e \u0433\u043e\u0442\u043e\u0432\u0438\u0439 \u043f\u0430\u043a\u0435\u0442. \u041f\u0440\u0438 \u043f\u0430\u043a\u0435\u0442\u0456 \u0441\u0438\u0441\u0442\u0435\u043c\u0430 \u0430\u0432\u0442\u043e\u043c\u0430\u0442\u0438\u0447\u043d\u043e \u0434\u043e\u0434\u0430\u0454 \u043e\u0431\u043b\u0430\u0434\u043d\u0430\u043d\u043d\u044f, \u0432\u0438\u0442\u0440\u0430\u0442\u043d\u0456 \u043c\u0430\u0442\u0435\u0440\u0456\u0430\u043b\u0438 \u0442\u0430 \u0430\u043a\u0441\u0435\u0441\u0443\u0430\u0440\u0438.',
      },
      // ─── Bizom\u00e1ny (Consignment) ───
      {
        type: 'feature',
        category: 'rental',
        titleHu:
          'Fogyoeszk\u00f6z bizom\u00e1ny kezel\u00e9s \u2014 sz\u00e1ll\u00edt\u00f3lev\u00e9l + elsz\u00e1mol\u00e1s',
        titleEn: 'Consumable consignment management \u2014 delivery note + settlement',
        titleDe: 'Verbrauchsmaterial-Konsignation \u2014 Lieferschein + Abrechnung',
        titleUk:
          '\u041a\u0435\u0440\u0443\u0432\u0430\u043d\u043d\u044f \u043a\u043e\u043d\u0441\u0438\u0433\u043d\u0430\u0446\u0456\u0454\u044e \u0432\u0438\u0442\u0440\u0430\u0442\u043d\u0438\u0445 \u043c\u0430\u0442\u0435\u0440\u0456\u0430\u043b\u0456\u0432 \u2014 \u043d\u0430\u043a\u043b\u0430\u0434\u043d\u0430 + \u0440\u043e\u0437\u0440\u0430\u0445\u0443\u043d\u043e\u043a',
        descriptionHu:
          '\u00daj \u00fczleti folyamat: p\u00e9ld\u00e1ul a v\u00e1s\u00e1rl\u00f3 b\u00e9rel egy sarokcsiszol\u00f3t \u00e9s elvisz mell\u00e9 25 db v\u00e1g\u00f3korongot bizom\u00e1nyba (nem fizet most). A rendszer sz\u00e1ll\u00edt\u00f3levelet \u00e1ll\u00edt ki (SZL-2026-0001). Visszahoz\u00e1skor: 20 db j\u00f6tt vissza, 5 db felhaszn\u00e1lva \u2192 az 5 db \u00e1ra r\u00e1ker\u00fcl a v\u00e9gs\u0151 sz\u00e1ml\u00e1ra. A 20 db visszaker\u00fcl a k\u00e9szletre.',
        descriptionEn:
          'New business flow: for example, the customer rents an angle grinder and takes 25 cutting discs on consignment (no payment now). The system issues a delivery note (SZL-2026-0001). On return: 20 came back, 5 used \u2192 the price of 5 goes on the final invoice. The 20 return to stock.',
        descriptionDe:
          'Neuer Gesch\u00e4ftsprozess: z.B. Kunde mietet Winkelschleifer und nimmt 25 Trennscheiben auf Konsignation (keine Zahlung jetzt). System erstellt Lieferschein (SZL-2026-0001). Bei R\u00fcckgabe: 20 zur\u00fcck, 5 verbraucht \u2192 Preis der 5 auf Endrechnung. Die 20 gehen zur\u00fcck ins Lager.',
        descriptionUk:
          '\u041d\u043e\u0432\u0438\u0439 \u0431\u0456\u0437\u043d\u0435\u0441-\u043f\u0440\u043e\u0446\u0435\u0441: \u043a\u043b\u0456\u0454\u043d\u0442 \u043e\u0440\u0435\u043d\u0434\u0443\u0454 \u0431\u043e\u043b\u0433\u0430\u0440\u043a\u0443 \u0456 \u0437\u0430\u0431\u0438\u0440\u0430\u0454 25 \u0432\u0456\u0434\u0440\u0456\u0437\u043d\u0438\u0445 \u0434\u0438\u0441\u043a\u0456\u0432 \u043d\u0430 \u043a\u043e\u043d\u0441\u0438\u0433\u043d\u0430\u0446\u0456\u044e (\u0431\u0435\u0437 \u043e\u043f\u043b\u0430\u0442\u0438). \u0421\u0438\u0441\u0442\u0435\u043c\u0430 \u0432\u0438\u0434\u0430\u0454 \u043d\u0430\u043a\u043b\u0430\u0434\u043d\u0443. \u041f\u0440\u0438 \u043f\u043e\u0432\u0435\u0440\u043d\u0435\u043d\u043d\u0456: 20 \u043f\u043e\u0432\u0435\u0440\u043d\u0443\u0442\u043e, 5 \u0432\u0438\u043a\u043e\u0440\u0438\u0441\u0442\u0430\u043d\u043e \u2192 \u0446\u0456\u043d\u0430 5 \u043d\u0430 \u0444\u0456\u043d\u0430\u043b\u044c\u043d\u0438\u0439 \u0440\u0430\u0445\u0443\u043d\u043e\u043a.',
      },
      {
        type: 'feature',
        category: 'rental',
        titleHu: 'Sz\u00e1ll\u00edt\u00f3lev\u00e9l PDF nyomtat\u00e1s',
        titleEn: 'Delivery note PDF printing',
        titleDe: 'Lieferschein-PDF-Druck',
        titleUk:
          '\u0414\u0440\u0443\u043a PDF \u043d\u0430\u043a\u043b\u0430\u0434\u043d\u043e\u0457',
        descriptionHu:
          'Minden bizom\u00e1ny kiad\u00e1shoz A4 sz\u00e1ll\u00edt\u00f3lev\u00e9l gener\u00e1l\u00f3dik (SZL-\u00c9\u00c9\u00c9\u00c9-NNNN sz\u00e1mmal). Tartalmazza: partner adatok, t\u00e9telek t\u00e1bl\u00e1zat mennyis\u00e9ggel \u00e9s egys\u00e9g\u00e1rral, bizom\u00e1ny \u00f6ss\u00e9rt\u00e9k, al\u00e1\u00edr\u00e1s mez\u0151k (\u00e1tad\u00f3/\u00e1tvev\u0151). A visszav\u00e9tel oldalon egy gombbal let\u00f6lthet\u0151 vagy kinyomtathat\u00f3.',
        descriptionEn:
          'An A4 delivery note is generated for each consignment dispatch (SZL-YYYY-NNNN number). Contains: partner details, items table with quantities and unit prices, total consignment value, signature fields (issuer/receiver). Downloadable/printable with one button on the return page.',
        descriptionDe:
          'F\u00fcr jede Konsignationsausgabe wird ein A4-Lieferschein generiert (SZL-JJJJ-NNNN). Enthalt: Partnerdaten, Artikeltabelle mit Mengen und Einheitspreisen, Gesamtkonsignationswert, Unterschriftsfelder. Per Klick herunterladbar auf der R\u00fcckgabeseite.',
        descriptionUk:
          '\u0414\u043b\u044f \u043a\u043e\u0436\u043d\u043e\u0457 \u0432\u0438\u0434\u0430\u0447\u0456 \u043a\u043e\u043d\u0441\u0438\u0433\u043d\u0430\u0446\u0456\u0457 \u0433\u0435\u043d\u0435\u0440\u0443\u0454\u0442\u044c\u0441\u044f \u043d\u0430\u043a\u043b\u0430\u0434\u043d\u0430 A4 (SZL-\u0420\u0420\u0420\u0420-NNNN). \u041c\u0456\u0441\u0442\u0438\u0442\u044c: \u0434\u0430\u043d\u0456 \u043f\u0430\u0440\u0442\u043d\u0435\u0440\u0430, \u0442\u0430\u0431\u043b\u0438\u0446\u044e \u0442\u043e\u0432\u0430\u0440\u0456\u0432, \u0437\u0430\u0433\u0430\u043b\u044c\u043d\u0443 \u0432\u0430\u0440\u0442\u0456\u0441\u0442\u044c, \u043f\u043e\u043b\u044f \u043f\u0456\u0434\u043f\u0438\u0441\u0443. \u0417\u0430\u0432\u0430\u043d\u0442\u0430\u0436\u0443\u0454\u0442\u044c\u0441\u044f \u043e\u0434\u043d\u0456\u0454\u044e \u043a\u043d\u043e\u043f\u043a\u043e\u044e \u043d\u0430 \u0441\u0442\u043e\u0440\u0456\u043d\u0446\u0456 \u043f\u043e\u0432\u0435\u0440\u043d\u0435\u043d\u043d\u044f.',
      },
      {
        type: 'feature',
        category: 'rental',
        titleHu: 'Bizom\u00e1ny elsz\u00e1mol\u00e1s a visszav\u00e9teln\u00e9l',
        titleEn: 'Consignment settlement during equipment return',
        titleDe: 'Konsignationsabrechnung bei Ger\u00e4ter\u00fcckgabe',
        titleUk:
          '\u0420\u043e\u0437\u0440\u0430\u0445\u0443\u043d\u043e\u043a \u043a\u043e\u043d\u0441\u0438\u0433\u043d\u0430\u0446\u0456\u0457 \u043f\u0440\u0438 \u043f\u043e\u0432\u0435\u0440\u043d\u0435\u043d\u043d\u0456 \u043e\u0431\u043b\u0430\u0434\u043d\u0430\u043d\u043d\u044f',
        descriptionHu:
          'A g\u00e9p visszav\u00e9telekor a Pénz\u00fcgyi elsz\u00e1mol\u00e1s l\u00e9p\u00e9sben megjelennek a bizom\u00e1ny t\u00e9telek. Minden t\u00e9teln\u00e9l be\u00e1ll\u00edthat\u00f3 a visszahozott mennyis\u00e9g. A rendszer automatikusan kisz\u00e1m\u00edtja a felhaszn\u00e1lt mennyis\u00e9get \u00e9s a felsz\u00e1m\u00edtand\u00f3 \u00f6sszeget. A v\u00e9gleges\u00edt\u00e9skor minden elment\u0151dik.',
        descriptionEn:
          'During equipment return, the Payment step shows consignment items. For each item, the returned quantity can be adjusted. The system automatically calculates the used quantity and the amount to charge. Everything is saved on finalization.',
        descriptionDe:
          'Bei der Ger\u00e4ter\u00fcckgabe zeigt der Zahlungsschritt die Konsignationsartikel. F\u00fcr jeden Artikel kann die zur\u00fcckgegebene Menge angepasst werden. Das System berechnet automatisch die verbrauchte Menge und den zu berechnenden Betrag.',
        descriptionUk:
          '\u041f\u0440\u0438 \u043f\u043e\u0432\u0435\u0440\u043d\u0435\u043d\u043d\u0456 \u043e\u0431\u043b\u0430\u0434\u043d\u0430\u043d\u043d\u044f \u043d\u0430 \u043a\u0440\u043e\u0446\u0456 \u041e\u043f\u043b\u0430\u0442\u0430 \u0432\u0456\u0434\u043e\u0431\u0440\u0430\u0436\u0430\u044e\u0442\u044c\u0441\u044f \u043a\u043e\u043d\u0441\u0438\u0433\u043d\u0430\u0446\u0456\u0439\u043d\u0456 \u0442\u043e\u0432\u0430\u0440\u0438. \u0414\u043b\u044f \u043a\u043e\u0436\u043d\u043e\u0433\u043e \u0442\u043e\u0432\u0430\u0440\u0443 \u043c\u043e\u0436\u043d\u0430 \u0432\u043a\u0430\u0437\u0430\u0442\u0438 \u043f\u043e\u0432\u0435\u0440\u043d\u0443\u0442\u0443 \u043a\u0456\u043b\u044c\u043a\u0456\u0441\u0442\u044c. \u0421\u0438\u0441\u0442\u0435\u043c\u0430 \u0430\u0432\u0442\u043e\u043c\u0430\u0442\u0438\u0447\u043d\u043e \u0440\u043e\u0437\u0440\u0430\u0445\u043e\u0432\u0443\u0454 \u0432\u0438\u043a\u043e\u0440\u0438\u0441\u0442\u0430\u043d\u0443 \u043a\u0456\u043b\u044c\u043a\u0456\u0441\u0442\u044c \u0456 \u0441\u0443\u043c\u0443 \u0434\u043e \u043d\u0430\u0440\u0430\u0445\u0443\u0432\u0430\u043d\u043d\u044f.',
      },
      // ─── Jav\u00edt\u00e1sok ───
      {
        type: 'fix',
        category: 'rental',
        titleHu:
          'B\u00e9rl\u00e9s visszav\u00e9tel: az oldal nem t\u00f6lt\u0151d\u00f6tt be egyes b\u00e9rl\u00e9sekn\u00e9l',
        titleEn: 'Rental return page did not load for some rentals',
        titleDe: 'R\u00fcckgabeseite wurde bei einigen Vermietungen nicht geladen',
        titleUk:
          '\u0421\u0442\u043e\u0440\u0456\u043d\u043a\u0430 \u043f\u043e\u0432\u0435\u0440\u043d\u0435\u043d\u043d\u044f \u043d\u0435 \u0437\u0430\u0432\u0430\u043d\u0442\u0430\u0436\u0443\u0432\u0430\u043b\u0430\u0441\u044f \u0434\u043b\u044f \u0434\u0435\u044f\u043a\u0438\u0445 \u043e\u0440\u0435\u043d\u0434',
        descriptionHu:
          'Ha a b\u00e9rl\u00e9s nem volt az els\u0151 oldalon (sok b\u00e9rl\u00e9s eset\u00e9n), a visszav\u00e9tel oldal \u00fcres maradt. Jav\u00edtva: a rendszer most k\u00f6zvetlen\u00fcl let\u00f6lti a b\u00e9rl\u00e9st, \u00e9s bet\u00f6lt\u00e9s k\u00f6zben t\u00f6lt\u0151 anim\u00e1ci\u00f3t mutat.',
        descriptionEn:
          'If the rental was not on the first page (many rentals), the return page was blank. Fixed: the system now fetches the rental directly and shows a loading animation.',
        descriptionDe:
          'Wenn die Vermietung nicht auf der ersten Seite war, blieb die R\u00fcckgabeseite leer. Behoben: Das System l\u00e4dt die Vermietung jetzt direkt und zeigt eine Ladeanimation.',
        descriptionUk:
          '\u042f\u043a\u0449\u043e \u043e\u0440\u0435\u043d\u0434\u0430 \u043d\u0435 \u0431\u0443\u043b\u0430 \u043d\u0430 \u043f\u0435\u0440\u0448\u0456\u0439 \u0441\u0442\u043e\u0440\u0456\u043d\u0446\u0456, \u0441\u0442\u043e\u0440\u0456\u043d\u043a\u0430 \u043f\u043e\u0432\u0435\u0440\u043d\u0435\u043d\u043d\u044f \u0431\u0443\u043b\u0430 \u043f\u043e\u0440\u043e\u0436\u043d\u044c\u043e\u044e. \u0412\u0438\u043f\u0440\u0430\u0432\u043b\u0435\u043d\u043e: \u0441\u0438\u0441\u0442\u0435\u043c\u0430 \u0437\u0430\u0432\u0430\u043d\u0442\u0430\u0436\u0443\u0454 \u043e\u0440\u0435\u043d\u0434\u0443 \u043d\u0430\u043f\u0440\u044f\u043c\u0443 \u0456 \u043f\u043e\u043a\u0430\u0437\u0443\u0454 \u0430\u043d\u0456\u043c\u0430\u0446\u0456\u044e \u0437\u0430\u0432\u0430\u043d\u0442\u0430\u0436\u0435\u043d\u043d\u044f.',
      },
      {
        type: 'fix',
        category: 'products',
        titleHu: 'Term\u00e9k keres\u00e9s jav\u00edtva a csomag szerkeszt\u0151ben',
        titleEn: 'Product search fixed in package editor',
        titleDe: 'Produktsuche im Paket-Editor behoben',
        titleUk:
          '\u041f\u043e\u0448\u0443\u043a \u043f\u0440\u043e\u0434\u0443\u043a\u0442\u0456\u0432 \u0432\u0438\u043f\u0440\u0430\u0432\u043b\u0435\u043d\u043e \u0432 \u0440\u0435\u0434\u0430\u043a\u0442\u043e\u0440\u0456 \u043f\u0430\u043a\u0435\u0442\u0456\u0432',
        descriptionHu:
          'A csomag szerkeszt\u0151ben a term\u00e9k keres\u00e9s kor\u00e1bban hib\u00e1t dobott \u2014 most m\u00e1r helyesen m\u0171k\u00f6dik (n\u00e9v, cikksz\u00e1m, m\u00e1rka alapj\u00e1n keres).',
        descriptionEn:
          'Product search in the package editor was previously returning an error \u2014 now works correctly (searches by name, SKU, brand).',
        descriptionDe:
          'Die Produktsuche im Paket-Editor gab zuvor einen Fehler zur\u00fcck \u2014 funktioniert jetzt korrekt (Suche nach Name, SKU, Marke).',
        descriptionUk:
          '\u041f\u043e\u0448\u0443\u043a \u043f\u0440\u043e\u0434\u0443\u043a\u0442\u0456\u0432 \u0443 \u0440\u0435\u0434\u0430\u043a\u0442\u043e\u0440\u0456 \u043f\u0430\u043a\u0435\u0442\u0456\u0432 \u0440\u0430\u043d\u0456\u0448\u0435 \u043f\u043e\u0432\u0435\u0440\u0442\u0430\u0432 \u043f\u043e\u043c\u0438\u043b\u043a\u0443 \u2014 \u0442\u0435\u043f\u0435\u0440 \u043f\u0440\u0430\u0446\u044e\u0454 \u043a\u043e\u0440\u0435\u043a\u0442\u043d\u043e (\u043f\u043e\u0448\u0443\u043a \u0437\u0430 \u043d\u0430\u0437\u0432\u043e\u044e, SKU, \u0431\u0440\u0435\u043d\u0434\u043e\u043c).',
      },
    ],
  },
  {
    version: '4.1.0',
    date: '2026-03-26',
    changes: [
      {
        type: 'feature',
        category: 'admin',
        titleEn: 'rPI Delta — Search, Filters & CSV Export',
        titleHu: 'rPI Delta — Keresés, szűrők és CSV export',
        titleDe: 'rPI Delta — Suche, Filter & CSV-Export',
        titleUk: 'rPI Delta — Пошук, фільтри та CSV експорт',
        descriptionEn:
          'SearchFilterBar component with text search, type/category filters, and client-side CSV export for changelog entries.',
        descriptionHu:
          'SearchFilterBar komponens szöveges kereséssel, típus/kategória szűrőkkel és kliens oldali CSV exporttal a változásnapló bejegyzésekhez.',
        descriptionDe:
          'SearchFilterBar-Komponente mit Textsuche, Typ-/Kategoriefiltern und clientseitigem CSV-Export für Changelog-Einträge.',
        descriptionUk:
          'Компонент SearchFilterBar з текстовим пошуком, фільтрами типу/категорії та клієнтським CSV експортом для записів журналу змін.',
      },
      {
        type: 'feature',
        category: 'admin',
        titleEn: 'rPI Delta — 4-Language Support (HU/EN/DE/UK)',
        titleHu: 'rPI Delta — 4 nyelv támogatás (HU/EN/DE/UK)',
        titleDe: 'rPI Delta — 4-Sprachen-Unterstützung (HU/EN/DE/UK)',
        titleUk: 'rPI Delta — Підтримка 4 мов (HU/EN/DE/UK)',
        descriptionEn:
          'Full bilingual content support across all changelog and release testing entries in Hungarian, English, German, and Ukrainian.',
        descriptionHu:
          'Teljes többnyelvű tartalom támogatás az összes változásnapló és release tesztelési bejegyzésnél magyar, angol, német és ukrán nyelven.',
        descriptionDe:
          'Vollständige mehrsprachige Inhaltsunterstützung für alle Changelog- und Release-Test-Einträge in Ungarisch, Englisch, Deutsch und Ukrainisch.',
        descriptionUk:
          'Повна багатомовна підтримка контенту для всіх записів журналу змін та тестування релізів угорською, англійською, німецькою та українською мовами.',
      },
      {
        type: 'feature',
        category: 'admin',
        titleEn: 'rPI Delta — Tester Checkpoint Auto-Save',
        titleHu: 'rPI Delta — Tesztelő checkpoint auto-mentés',
        titleDe: 'rPI Delta — Tester-Checkpoint automatisches Speichern',
        titleUk: 'rPI Delta — Автозбереження контрольних точок тестувальника',
        descriptionEn:
          'Step checkbox and comment fields auto-save with 1.5s debounce, blur event, and beforeunload protection.',
        descriptionHu:
          'Lépés checkbox és komment mezők auto-mentése 1.5s debounce-szal, blur eseményre és beforeunload védelemmel.',
        descriptionDe:
          'Schritt-Checkbox und Kommentarfelder speichern automatisch mit 1,5s Debounce, Blur-Event und Beforeunload-Schutz.',
        descriptionUk:
          'Автозбереження чекбоксів кроків та полів коментарів з затримкою 1.5с, подією blur та захистом beforeunload.',
      },
      {
        type: 'feature',
        category: 'admin',
        titleEn: 'rPI Delta — Tester Name & Timestamp Display',
        titleHu: 'rPI Delta — Tesztelő neve és időpont megjelenítése',
        titleDe: 'rPI Delta — Anzeige von Testername und Zeitstempel',
        titleUk: 'rPI Delta — Відображення імені тестувальника та часу',
        descriptionEn:
          'Each test step now displays who completed it and when, loaded from the database.',
        descriptionHu:
          'Minden tesztelési lépésnél megjelenik, ki és mikor végezte el, adatbázisból betöltve.',
        descriptionDe:
          'Jeder Testschritt zeigt nun an, wer ihn wann abgeschlossen hat, aus der Datenbank geladen.',
        descriptionUk:
          'Кожен тестовий крок тепер відображає, хто його виконав і коли, завантажуючи дані з бази даних.',
      },
      {
        type: 'feature',
        category: 'inventory',
        titleEn: 'Sprint Q — Supplier Import, Cross-sell & Internal Transfer',
        titleHu: 'Sprint Q — Beszállítói import, cross-sell és átvezetés',
        titleDe: 'Sprint Q — Lieferantenimport, Cross-Selling & interne Übertragung',
        titleUk: 'Sprint Q — Імпорт постачальників, крос-продаж та внутрішній трансфер',
        descriptionEn:
          'Three new Sprint Q stories: supplier catalog import (Q-IMP-3), cross-sell invoice handling (Q-XSL-1), and inter-warehouse stock transfer (Q-TRF-1).',
        descriptionHu:
          'Három új Sprint Q story: beszállítói katalógus import (Q-IMP-3), cross-sell számla kezelés (Q-XSL-1) és raktárközi készletátvezetés (Q-TRF-1).',
        descriptionDe:
          'Drei neue Sprint-Q-Stories: Lieferantenkatalog-Import (Q-IMP-3), Cross-Selling-Rechnungsabwicklung (Q-XSL-1) und Lagerübertragung (Q-TRF-1).',
        descriptionUk:
          'Три нові історії Sprint Q: імпорт каталогу постачальників (Q-IMP-3), обробка рахунків крос-продажу (Q-XSL-1) та міжскладське переміщення запасів (Q-TRF-1).',
      },
      {
        type: 'feature',
        category: 'integration',
        titleEn: 'Chatwoot & PIr Porter Integration',
        titleHu: 'Chatwoot és PIr Porter integráció',
        titleDe: 'Chatwoot & PIr Porter Integration',
        titleUk: 'Інтеграція Chatwoot та PIr Porter',
        descriptionEn:
          'New iframe integration pages for Chatwoot customer support and PIr Porter customer portal within the ERP.',
        descriptionHu:
          'Új iframe integrációs oldalak a Chatwoot ügyfélszolgálathoz és a PIr Porter ügyfélportálhoz az ERP-n belül.',
        descriptionDe:
          'Neue Iframe-Integrationsseiten für Chatwoot-Kundensupport und PIr Porter-Kundenportal innerhalb des ERP.',
        descriptionUk:
          'Нові сторінки інтеграції iframe для служби підтримки Chatwoot та клієнтського порталу PIr Porter в ERP.',
      },
      {
        type: 'feature',
        category: 'service',
        titleEn: 'Helpdesk v3.0 ERP Integration',
        titleHu: 'Helpdesk v3.0 ERP integráció',
        titleDe: 'Helpdesk v3.0 ERP-Integration',
        titleUk: 'Інтеграція Helpdesk v3.0 з ERP',
        descriptionEn:
          'Service worksheet data flows to Google Apps Script Helpdesk with secure context passing.',
        descriptionHu:
          'Szerviz munkalap adatok átfolynak a Google Apps Script Helpdesk-be biztonságos kontextus átadással.',
        descriptionDe:
          'Servicedaten fließen mit sicherer Kontextübergabe in das Google Apps Script Helpdesk.',
        descriptionUk:
          'Дані сервісних нарядів передаються в Google Apps Script Helpdesk із безпечним передаванням контексту.',
      },
      {
        type: 'feature',
        category: 'integration',
        titleEn: 'Twenty CRM, Chatwoot & Horilla HR in Demo Environment',
        titleHu: 'Twenty CRM, Chatwoot és Horilla HR demo környezetben',
        titleDe: 'Twenty CRM, Chatwoot & Horilla HR in Demo-Umgebung',
        titleUk: 'Twenty CRM, Chatwoot та Horilla HR у демо-середовищі',
        descriptionEn:
          'All three external integrations (CRM, support, HR) added to demo Docker Compose for UAT testing.',
        descriptionHu:
          'Mind a három külső integráció (CRM, ügyfélszolgálat, HR) hozzáadva a demo Docker Compose-hoz UAT teszteléshez.',
        descriptionDe:
          'Alle drei externen Integrationen (CRM, Support, HR) wurden zur Demo-Docker-Compose für UAT-Tests hinzugefügt.',
        descriptionUk:
          'Усі три зовнішні інтеграції (CRM, підтримка, HR) додано до демо Docker Compose для UAT тестування.',
      },
      {
        type: 'fix',
        category: 'sales',
        titleEn: '15% Discount Cap Fix',
        titleHu: '15% kedvezmény felső határ javítás',
        titleDe: 'Korrektur der 15%-Rabattobergrenze',
        titleUk: 'Виправлення верхньої межі знижки 15%',
        descriptionEn:
          'Fixed discount calculation to correctly enforce the 15% maximum cap across all discount types.',
        descriptionHu:
          'Kedvezmény számítás javítva, hogy helyesen érvényesítse a 15%-os maximális felső határt minden kedvezménytípusnál.',
        descriptionDe:
          'Rabattberechnung korrigiert, um die 15%-Obergrenze für alle Rabatttypen korrekt durchzusetzen.',
        descriptionUk:
          'Виправлено розрахунок знижки для правильного застосування максимальної межі 15% для всіх типів знижок.',
      },
      {
        type: 'fix',
        category: 'service',
        titleEn: 'Service Worksheet DI Registration Fix',
        titleHu: 'Szerviz munkalap DI regisztráció javítás',
        titleDe: 'Korrektur der Service-Arbeitsblatt DI-Registrierung',
        titleUk: 'Виправлення реєстрації DI сервісного наряду',
        descriptionEn:
          'WorksheetItemService was missing from ServiceModule providers, causing runtime injection errors.',
        descriptionHu:
          'A WorksheetItemService hiányzott a ServiceModule providers-ből, ami futásidejű injection hibákat okozott.',
        descriptionDe:
          'WorksheetItemService fehlte in den ServiceModule-Providers, was zu Laufzeit-Injektionsfehlern führte.',
        descriptionUk:
          "WorksheetItemService був відсутній у провайдерах ServiceModule, що спричиняло помилки ін'єкції під час виконання.",
      },
      {
        type: 'improvement',
        category: 'admin',
        titleEn: 'rPI Delta Branding (Release Hub → rPI Delta)',
        titleHu: 'rPI Delta branding (Release Hub → rPI Delta)',
        titleDe: 'rPI Delta Branding (Release Hub → rPI Delta)',
        titleUk: 'Брендинг rPI Delta (Release Hub → rPI Delta)',
        descriptionEn:
          'Renamed Release Hub to rPI Delta across all UI labels, navigation, and page titles.',
        descriptionHu:
          'Release Hub átnevezve rPI Delta-ra az összes UI feliraton, navigációban és oldalcímben.',
        descriptionDe:
          'Release Hub wurde in rPI Delta umbenannt — alle UI-Beschriftungen, Navigation und Seitentitel.',
        descriptionUk:
          'Release Hub перейменовано на rPI Delta в усіх мітках інтерфейсу, навігації та заголовках сторінок.',
      },
      {
        type: 'improvement',
        category: 'admin',
        titleEn: 'E-76 UAT Hardening (11 Stories, 114 New Tests)',
        titleHu: 'E-76 UAT Hardening (11 story, 114 új teszt)',
        titleDe: 'E-76 UAT-Härtung (11 Stories, 114 neue Tests)',
        titleUk: 'E-76 UAT зміцнення (11 історій, 114 нових тестів)',
        descriptionEn:
          'Comprehensive UAT hardening sprint covering RLS, TOCTOU, cash register, Helmet, health checks, VAT, storno, IDOR, E2E, and close permissions.',
        descriptionHu:
          'Átfogó UAT hardening sprint: RLS, TOCTOU, kassza, Helmet, health check, ÁFA, storno, IDOR, E2E és zárás jogosultság.',
        descriptionDe:
          'Umfassender UAT-Härtungs-Sprint: RLS, TOCTOU, Kasse, Helmet, Health-Checks, MwSt, Storno, IDOR, E2E und Abschlussberechtigungen.',
        descriptionUk:
          'Комплексний спринт зміцнення UAT: RLS, TOCTOU, каса, Helmet, перевірки стану, ПДВ, сторно, IDOR, E2E та права закриття.',
      },
      {
        type: 'improvement',
        category: 'admin',
        titleEn: '375 New Tests — Invoice Engine, E2E Journeys, Dashboard',
        titleHu: '375 új teszt — számlázó motor, E2E journey-k, dashboard',
        titleDe: '375 neue Tests — Rechnungsmotor, E2E-Journeys, Dashboard',
        titleUk: '375 нових тестів — рахунковий двигун, E2E подорожі, панель',
        descriptionEn:
          'Major test coverage expansion: invoice engine unit tests, end-to-end user journeys, and dashboard component tests.',
        descriptionHu:
          'Jelentős tesztlefedettség bővítés: számlázó motor unit tesztek, végponttól végpontig felhasználói journey-k és dashboard komponens tesztek.',
        descriptionDe:
          'Große Testabdeckungserweiterung: Rechnungsmotor-Unit-Tests, End-to-End-User-Journeys und Dashboard-Komponententests.',
        descriptionUk:
          'Значне розширення тестового покриття: модульні тести рахункового двигуна, наскрізні подорожі користувача та тести компонентів панелі.',
      },
      {
        type: 'improvement',
        category: 'admin',
        titleEn: 'rPI Delta Contrast Tab Colors',
        titleHu: 'rPI Delta kontrasztos fülszínek',
        titleDe: 'rPI Delta kontraststarke Tab-Farben',
        titleUk: 'rPI Delta контрастні кольори вкладок',
        descriptionEn:
          'Changelog tab uses emerald color, Release Testing tab uses amber for better visual distinction.',
        descriptionHu:
          'Változásnapló fül smaragd színt, Release Tesztelés fül borostyán színt használ a jobb vizuális megkülönböztetéshez.',
        descriptionDe:
          'Der Changelog-Tab verwendet Smaragdfarbe, der Release-Testing-Tab Bernstein für bessere visuelle Unterscheidung.',
        descriptionUk:
          'Вкладка журналу змін використовує смарагдовий колір, вкладка тестування релізу — бурштиновий для кращого візуального розрізнення.',
      },
    ],
  },
  {
    version: '4.0.0',
    date: '2026-03-25',
    changes: [
      {
        type: 'feature',
        category: 'admin',
        titleEn: 'Release Hub — Changelog & Release Testing',
        titleHu: 'Release Hub — Változásnapló & Release Tesztelés',
        descriptionEn:
          'Unified Release Hub page with Changelog and Release Testing tabs, cross-linking, deep linking, and CSV export.',
        descriptionHu:
          'Egységes Release Hub oldal Változásnapló és Release Tesztelés fülekkel, kereszthivatkozásokkal, mélyhivatkozásokkal és CSV exporttal.',
      },
    ],
  },
];
